import { useSelector } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'
import { Text } from '@homebot/shared-ui-swashbuckle'
import { RootState } from '../../../../../types/rootState'
import { formatCurrency } from '../../../../../helpers/formatters'

export const MSG = defineMessages({
  whenCanYouRemovePmiProvided: {
    id: 'PMI.whenCanYouRemoveHeaderProvided',
    defaultMessage:
      'When can you remove your {monthlyPmiPaymentNode} monthly mortgage insurance (PMI)?',
  },
})

export const PmiHeaderText = () => {
  const intl = useIntl()
  const payment = useSelector<RootState, number | null>(
    state => state.pmi.monthlyPmiPayment
  )

  return (
    <>
      {intl.formatMessage(MSG.whenCanYouRemovePmiProvided, {
        monthlyPmiPaymentNode: (
          <Text as='span' fontWeight='semibold'>
            {formatCurrency(payment)}
          </Text>
        ),
      })}
    </>
  )
}
